import { useContext, useEffect, useState } from "react";
import { domainProvider } from "../../../contexts/DomainContext";
import i18next from "i18next";
import { Link } from "react-router-dom";
import { BsCart2 } from "react-icons/bs";
import axios from "axios";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 5 },
  desktop: { breakpoint: { max: 3000, min: 1150 }, items: 4 },
  tablet: { breakpoint: { max: 1150, min: 760 }, items: 2 },
  mobile: { breakpoint: { max: 760, min: 0 }, items: 1 },
};

export default function RelatedProduct({ productId }) {
  const { customdomain } = useContext(domainProvider);
  const [products, setProducts] = useState([]);
  const language = i18next.language;

  useEffect(() => {
    const api = `${process.env.REACT_APP_APIURL}/vendor/store/getAllSuggestedProducts/${productId}`;
    const fetchTopProducts = async () => {
      try {
        const res = await axios.get(api);
        const response = res.data;
        if (response.status_code === 200 && response.data.length > 0) {
          setProducts(response.data);
        }
      } catch (error) {
        console.error("Error fetching suggested products:", error);
      }
    };
    fetchTopProducts();
  }, [productId]);

  const generateProductLink = (productId) => {
    return customdomain === "aitech.com.sa"
      ? `/storeName/product_details/${productId}`
      : `/product_details/${productId}`;
  };

  return (
    <div className=" px-6 pb-12 pt-4 mt-10 my-10">
      <p className="text-3xl text-gray-700 font-semibold mb-6 text-center ">Related Products</p>
      <Carousel interval={2000} responsive={responsive}>
        {products.map((item, idx) => (
          <div key={idx} className="px-2"> {/* ⬅️ Horizontal padding for spacing */}
            <div
              className="relative bg-white  shadow hover:shadow-lg transform hover:scale-[1.01] transition-all duration-300 ease-in-out max-w-[360px] mx-auto"
            >
              <div className="absolute top-3 right-3 bg-black text-white text-sm px-3 py-1 rounded-full z-10">
                {item.product_price} ر.س
              </div>

              <Link to={generateProductLink(item.product_id)}>
                <div className="w-full h-[300px]  overflow-hidden">
                  <img
                    src={item.thumbnail_image}
                    alt={
                      language === "ar" && item.product_name_ar
                        ? item.product_name_ar
                        : item.product_name
                    }
                    className="w-full h-full object-cover"
                  />
                </div>
              </Link>

              <div className="p-4 text-center">
                <h2 className="text-gray-800 text-[16px] font-semibold  line-clamp-2">
                  <Link to={generateProductLink(item.product_id)} className="hover:text-blue-600 text-blue-600 transition-colors duration-200 font-poppin">
                    {language === "ar" && item.product_name_ar
                      ? item.product_name_ar
                      : item.product_name}

                  </Link>
                </h2>

                <Link
                  to={generateProductLink(item.product_id)}
                  className="inline-flex items-center gap-2 bg-[#F97316] hover:bg-[#F97316] text-white text-sm px-4 py-2 rounded-full mt-2  transition-colors"
                >
                  <BsCart2 />
                  {language === "ar" ? "إضافة إلى السلة" : "Add to cart"}
                </Link>
              </div>
            </div>
          </div>
        ))}
      </Carousel>

    </div>
  );
}
